// extracted by mini-css-extract-plugin
export default {"labelRow":"InfoLabel_labelRow__MOFzc","infoWrap":"InfoLabel_infoWrap__vHoD-","infoIcon":"InfoLabel_infoIcon__Y2i7U","tooltip":"InfoLabel_tooltip__ZrE7V"};